export default __webpack_public_path__ + "static/media/income_square.71846ce3.svg";